<template>
  <div id="member" >
    <div class="add" >
      <van-icon class="icon" name="add-o" />
      <span>管理会员省份</span>
    </div>
    <div class="main" >
      <h4>您的2018年度会员已经失效</h4>
      <p>您需要支付300元会员费用，以便正常启用会员功能</p>
    </div>

    <van-button size="large" class="btn" >去付款</van-button>
    <div>返回协会官网</div>

  </div>
</template>
<script>
import Vue from 'vue'
import { Field, Button, Icon } from 'vant'
Vue.use(Field).use(Button).use(Icon)
export default {
  name: 'ReplacePhone',
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<style>

  #member {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: white;
  }

  #member .add {
    padding: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  #member .main {
    margin-top: 50px;
  }

  #member .icon {
    font-size: 30px;
  }

  #member .main h4 {
    font-size: 16px;
    text-align: center;
  }

  #member .main p {
    font-size: 14px;
    line-height: 1.3;
    text-align: center;
  }

  #member .btn {
    margin-top: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/membership-expired.vue